import { Spin } from "antd";

const LoadingScreen = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <Spin size="large" />
    </div>
  );
};

export default LoadingScreen;
